import { Loader2 } from "lucide-react";

interface LoaderProps {
  text?: string;
  className?: string;
}

export function Loader({ text = "Memuat data...", className = "h-64" }: LoaderProps) {
  return (
    <div className={`flex flex-col items-center justify-center w-full space-y-3 ${className}`}>
      <Loader2 className="w-8 h-8 animate-spin text-primary" />
      <span className="text-sm font-medium text-slate-500">{text}</span>
    </div>
  );
}
